module.exports = __webpack_public_path__ + "img/4.2c20b245.png";